(function($) {
    "use strict";

    if (!$('.hub-page-experts').length) return;

    var _pager = new PHI.Pager();

    function _render_item(item, count) {
        var art = $('<article class="hub-page-results-item">');

        art.addClass((0 === (count + 1) % 3) ? 'column-third-last' : 'column-third');

        var a = $('<a href="' + item.url + '">');
        var img = $('<img class="expert" src="' + item.headshot_url + '">');
        var h2 = $('<h2>');

        h2.text(item.title);

        var div = $('<div class="hub-page-results-item__title">');

        div.text(item.job_title);

        img.prop('alt', item.title);

        a.append(img);

        art.append(a);

        a = $('<a href="' + item.url + '">');
        a.append(h2);
        art.append(a);
        art.append(div);

        return art;
    }

    function _got_experts(d) {
        $('.loading-overlay').hide();

        if (!PHI.api.handleReturn(d)) return;

        var exec_items = d.data ? d.data.executives : [],
            advisor_items = d.data ? d.data.advisors : [],
            staff_items = d.data ? d.data.staff : [],
            total = d.data ? d.data.total_found : 0,
            pages = Math.ceil(total / PHI.api.PAGE_SIZE_EXPERTS),
            list = $('#results-list');

        list.empty();

        _pager.render(total, PHI.api.PAGE_SIZE_EXPERTS);

        if (0 === total) {
            list.append('<div class="content-grid-row">No results found.</div>');

            return;
        }

        var count = 0,
            item = null,
            currentRow = null,
            art = null;

        // exec team first
        if (exec_items.length > 0) {
            list.append('<div class="content-grid-row hub-page-results hub-page-results-header">Executive Leadership Team</div>');

            for (var i = 0; i < exec_items.length; i++) {
                item = exec_items[i];

                if (0 === count % 3) {
                    if (currentRow) list.append(currentRow);

                    currentRow = $('<div class="content-grid-row hub-page-results hub-page-results-staff-row">');
                }

                currentRow.append(_render_item(item, count));
                count++;
            }

            while (count % 3 !== 0) {
                art = $('<article class="hub-page-results-item">');
                art.addClass((0 === (count + 1) % 3) ? 'column-third-last' : 'column-third');
                currentRow.append(art);
                count++;
            }

            list.append(currentRow);
        }

        // then advisors
        if (advisor_items.length > 0) {
            list.append('<div class="content-grid-row hub-page-results hub-page-results-header">Advisors</div>');
            
            count = 0;
            currentRow = null;

            for (var i = 0; i < advisor_items.length; i++) {
                item = advisor_items[i];

                if (0 === count % 3) {
                    if (currentRow) list.append(currentRow);

                    currentRow = $('<div class="content-grid-row hub-page-results hub-page-results-staff-row">');
                }

                currentRow.append(_render_item(item, count));
                count++;
            }

            while (count % 3 !== 0) {
                art = $('<article class="hub-page-results-item">');
                art.addClass((0 === (count + 1) % 3) ? 'column-third-last' : 'column-third');
                currentRow.append(art);
                count++;
            }

            list.append(currentRow);
        }

        // then staff
        if (staff_items.length > 0) {
            if (exec_items.length > 0 || advisor_items.length > 0) list.append('<div class="content-grid-row hub-page-results hub-page-results-header">Staff</div>');

            count = 0;
            currentRow = null;

            for (var i = 0; i < staff_items.length; i++) {
                item = staff_items[i];

                if (0 === count % 3) {
                    if (currentRow) list.append(currentRow);

                    currentRow = $('<div class="content-grid-row hub-page-results hub-page-results-staff-row">');
                }

                currentRow.append(_render_item(item, count));
                count++;
            }

            while (count % 3 !== 0) {
                art = $('<article class="hub-page-results-item">');
                art.addClass((0 === (count + 1) % 3) ? 'column-third-last' : 'column-third');
                currentRow.append(art);
                count++;
            }

            list.append(currentRow);
        }
    }

    function _expert_filter(e) {
        var offset = 0;

        if (e) {
            if (e.params && 'unselect' === e.params._type) {
                $(e.target).val('');
                _pager.reset();
            } else if ('pagination' === e.type) offset = _pager.offset();
            else _pager.reset();
        }

        var search = $('#expert-keyword').val(),
            expertise = $('#hub-page-filter-expert-expertise option:selected').text();

        $('.loading-overlay').show();

        PHI.api.getExperts(search, expertise, offset, _got_experts);
    }


    $(function() {
        $('.loading-overlay').show();

        $('#hub-page-filter-expert-expertise').on('select2:select', _expert_filter);
        $('#hub-page-filter-expert-expertise').on('select2:unselect', _expert_filter);

        $('#expert-keyword').on('keydown', _.debounce(_expert_filter, 1000));

        _pager.init('#pager-container', '.hub-page-filter', _expert_filter);

        PHI.api.getExperts(null, null, 0, _got_experts);
    });
})(jQuery);
